module.exports = [{"type":"title","text":"2024-03-04"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續調整接口:新增下單類型 TRAILING_TP_SL（移動止盈止損）"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-03-04.json
// module id = 3c71
// module chunks = 3